import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { SEOHead } from "../components/SEOHead";
import { clipAlt } from "../lib/seoHtml";
import { Sidebar } from "../components/Layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogListPage({ navPages }) {
  const [data, setData] = useState({ posts: [], total: 0, page: 1, pages: 0 });
  const [loading, setLoading] = useState(true);
  const [pg, setPg] = useState(1);
  useEffect(() => { setLoading(true); axios.get(`${API}/blog?page=${pg}`).then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false)); }, [pg]);
  return (
    <div data-testid="blog-list-page">
      <SEOHead title="House Cleaning Tips & News Blog — DFW TX" description="Expert home cleaning tips, news and advice from Lazy Days Home Services in Arlington, Mansfield, Grand Prairie & Fort Worth TX. Fresh posts added regularly." keywords="cleaning news, cleaning tips, house cleaning advice, arlington tx cleaning blog" />
      <div className="page-header"><h1>Cleaning News</h1></div>
      <div className="main-layout">
        <div className="main-content">
          {loading ? <div className="loading-spinner"></div> : data.posts.length === 0 ? <div className="content-panel"><p>No cleaning news posts yet. Check back soon!</p></div> : (
            <div className="blog-list" data-testid="blog-list">
              {data.posts.map(p => (<Link to={`/cleaning-news/${p.slug}`} className="blog-card" key={p.id} data-testid={`blog-card-${p.slug}`}>
                {p.featured_image && <img src={p.featured_image} alt={clipAlt(p.featured_image_alt || p.title)} title={clipAlt(p.featured_image_alt || p.title)} className="blog-card-image" loading="lazy" width="400" height="225" />}
                <div className="blog-card-content"><h2>{p.title}</h2><div className="blog-meta">{new Date(p.date).toLocaleDateString()} | {p.author}</div><p>{p.excerpt}</p><span className="blog-read-more">Read More →</span></div></Link>))}
              {data.pages > 1 && (<div className="blog-pagination">{Array.from({ length: data.pages }, (_, i) => (<button key={i} className={pg === i + 1 ? "active" : ""} onClick={() => setPg(i + 1)}>{i + 1}</button>))}</div>)}
            </div>
          )}
        </div>
        <Sidebar navPages={navPages} />
      </div>
    </div>
  );
}
